
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/destinations/adikteev",
      function () {
        return require("private-next-pages/destinations/adikteev.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/destinations/adikteev"])
      });
    }
  